// extracted by mini-css-extract-plugin
export default {"printerSetup":"PrinterSettings_printerSetup__PxtXz"};